import React, { useEffect, useState } from "react";
import { getAllVideos } from '../services/videoService';
import VideoCard from '../components/common/VideoCard';
import PageHeader from '../components/PageHeader';

const VideosGallery = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedVideo, setSelectedVideo] = useState(null);
  

   const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Pages', link: '/pages' },
    { label: 'Video', active: true },
  ];

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const data = await getAllVideos();
        setVideos(data);
      } catch (error) {
        console.error("Failed to fetch videos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  const handleVideoClick = (video) => {
    setSelectedVideo(video);
  };

  const handleClose = () => {
    setSelectedVideo(null);
  };

  const getYoutubeId = (url) => {
    const urlObj = new URL(url);
    return urlObj.searchParams.get("v");
  };

  return (
    <div>
      {/* Page Header */}
      <PageHeader title="Videos Gallery" breadcrumbs={breadcrumbs} />

      <div className="container-xxl py-5">
        <div className="container">
          <div
            className="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: 600 }}
          >
            <h6 className="section-title bg-white text-center text-primary px-3">
              Videos
            </h6>
            <h1 className="display-6 mb-4">Explore Our Video Gallery</h1>
          </div>

          {loading ? (
            <p className="text-center">Loading videos...</p>
          ) : (
            <div className="row g-4">
              {videos.map((video) => (
                <VideoCard
                  key={video.id}
                  video={video}
                  onClick={handleVideoClick}
                />
              ))}
            </div>
          )}

          {/* Modal */}
          {selectedVideo && (
            <div
              className="modal show d-block"
              tabIndex="-1"
              onClick={handleClose}
              style={{ backgroundColor: "rgba(0,0,0,0.7)" }}
            >
              <div
                className="modal-dialog modal-dialog-centered modal-lg"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">{selectedVideo.title}</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleClose}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="embed-responsive embed-responsive-16by9">
                      <iframe
                        className="embed-responsive-item"
                        src={`https://www.youtube.com/embed/${getYoutubeId(
                          selectedVideo.videoUrl
                        )}`}
                        allowFullScreen
                        title={selectedVideo.title}
                        width="100%"
                        height="400"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default VideosGallery;